import React from 'react';

import Button from 'devextreme-react/button';
import HtmlEditor from 'devextreme-react/html-editor';

import DataModelView from '../common/view/DataModelView';

import './MemoPaneView.css';

export default class MemoEditorView extends DataModelView {
  constructor(props) {
    super(props);

    this.clickVisibilityHandler = this.onClickVisibility.bind(this);
    this.clickMoveUpHandler = this.onClickMoveUp.bind(this);
    this.clickMoveDownHandler = this.onClickMoveDown.bind(this);
    this.clickDeleteHandler = this.onClickDelete.bind(this);
    this.htmlContentChangedHandler = this.onHtmlContentChanged.bind(this);
  }

  getIntegratedPropertyNames() {
    return [
      'isNew',
      'isModified',
      'currentHtmlContent',
      'currentOnlyVisibleToPowerex',
      'enableEditVisibility',
      'enableEditContent',
      'enableMoveUp',
      'enableMoveDown'
    ];
  }

  render() {
    return (
      <div className="pwx-memo-sidebar">
        {this.props.editModeActive ? this.renderEditTitleBar() : (<div />)}
        <HtmlEditor
          readOnly={!this.props.editModeActive || !this.state.enableEditContent}
          value={this.state.currentHtmlContent}
          onValueChanged={this.htmlContentChangedHandler}
        />
      </div>
    );
  }

  renderEditTitleBar() {
    return (
      <div className="pwx-memo-notes-header">
        <div className="pwx-memo-notes-title-bar">
          <div className="pwx-memo-notes-title" />
          <Button
            type="normal"
            icon="group"
            hint={this.state.currentOnlyVisibleToPowerex ? "Visible to Powerex Users Only" : "Visible to Powerex & External Users"}
            text={this.state.currentOnlyVisibleToPowerex ? "Powerex" : "External"}
            onClick={this.clickVisibilityHandler}
            visible={true}
          />
          <Button
            type="normal"
            disabled={!this.state.enableMoveUp}
            icon="arrowup"
            hint="Move Memo Up"
            onClick={this.clickMoveUpHandler}
            visible={true}
          />
          <Button
            type="normal"
            disabled={!this.state.enableMoveDown}
            icon="arrowdown"
            hint="Move Memo Down"
            onClick={this.clickMoveDownHandler}
            visible={true}
          />
          <Button
            type="normal"
            disabled={!this.state.enableEditContent}
            icon="remove"
            hint="Delete Memo"
            onClick={this.clickDeleteHandler}
            visible={true}
          />
        </div>
      </div>
    );
  }

  onClickVisibility() {
    this.dataModel.toggleVisibility();
  }

  onClickMoveUp() {
    this.dataModel.moveMemoUp();
  }

  onClickMoveDown() {
    this.dataModel.moveMemoDown();
  }

  onClickDelete() {
    this.dataModel.deleteMemo();
  }

  onHtmlContentChanged(event) {
    this.dataModel.editMemoContent(event.value);
  }
}
